import axios from 'axios';
import store from './store';
import router from './router';

// AXIOS HTTP client (for REST)
const AXIOS = axios.create({
  baseURL: '/license-api',
});

// Interceptor which will be executed every API call
AXIOS.interceptors.response.use((response) => {
  return response;
}, (error) => {
  // Global handling if status is FORBIDDEN (403)
  if (error.response.status === 403) {
    if (!store.getters.getUser) {
      // No user signed in
      store.commit('setError', 'auth.error.noAuthSignedIn');
    } else {
      // User doesn't have the right authorities, logout the current user to force a new login
      store.dispatch("userSignOut", { error: 'auth.error.notAuthorizedAndNoSession' });
    }
    // Default routing to login page after a response with status 403
    router.push('/application/signIn');
  }
  return Promise.reject(error);
});

export { AXIOS };
